<app-legal-layout
  eyebrow="Rechtliches"
  title="Datenschutzerklärung"
  lastUpdated="Juni 2026">

  <h2>1. Verantwortlicher</h2>
  <p>
    Verantwortlicher für die Datenverarbeitung auf dieser Website im Sinne der
    Datenschutz-Grundverordnung (DSGVO) ist:
  </p>
  <address class="cr-legal__address">
    <strong>Kulatrix UG (haftungsbeschränkt)</strong><br>
    Alarichstraße 18<br>
    42281 Wuppertal<br>
    Deutschland<br><br>
    Telefon: <a href="tel:+4915252629106">+49 152 52629106</a><br>
    E-Mail: <a href="mailto:info&#64;kulatrix.com">info&#64;kulatrix.com</a><br><br>
    Vertretungsberechtigter Geschäftsführer: Valentin Kulagin
  </address>

  <h2>2. Kontakt in Datenschutzfragen</h2>
  <p>
    Für Fragen zum Datenschutz und zur Geltendmachung Ihrer Rechte erreichen Sie uns unter:
    <strong><a href="mailto:datenschutz&#64;kulatrix.com">datenschutz&#64;kulatrix.com</a></strong>
  </p>
  <p>Ein Datenschutzbeauftragter ist nach § 38 BDSG derzeit nicht zu bestellen.</p>

  <h2>3. Allgemeines zur Datenverarbeitung</h2>
  <p>
    Wir verarbeiten personenbezogene Daten unserer Nutzer grundsätzlich nur, soweit dies zur
    Bereitstellung einer funktionsfähigen Website sowie unserer Inhalte und Leistungen erforderlich ist.
    Die Verarbeitung erfolgt regelmäßig nur nach Einwilligung des Nutzers (Art. 6 Abs. 1 lit. a DSGVO),
    zur Vertragserfüllung (Art. 6 Abs. 1 lit. b DSGVO), aufgrund einer rechtlichen Verpflichtung
    (Art. 6 Abs. 1 lit. c DSGVO) oder berechtigter Interessen (Art. 6 Abs. 1 lit. f DSGVO).
  </p>

  <h2>4. Bereitstellung der Website und Server-Logfiles</h2>
  <h3>Beschreibung</h3>
  <p>
    Bei jedem Aufruf unserer Website erfasst unser System automatisiert Daten und Informationen vom
    Computersystem des aufrufenden Rechners. Folgende Daten werden hierbei erhoben:
  </p>
  <ul>
    <li>IP-Adresse (gekürzt/anonymisiert nach 7 Tagen)</li>
    <li>Datum und Uhrzeit des Zugriffs</li>
    <li>aufgerufene URL und HTTP-Statuscode</li>
    <li>übertragene Datenmenge</li>
    <li>Referrer-URL</li>
    <li>verwendeter Browser, Betriebssystem und Sprache</li>
  </ul>
  <h3>Rechtsgrundlage</h3>
  <p>
    Art. 6 Abs. 1 lit. f DSGVO. Unser berechtigtes Interesse liegt in der Sicherstellung des Betriebs,
    der IT-Sicherheit und der Missbrauchsabwehr.
  </p>
  <h3>Speicherdauer</h3>
  <p>Logfiles werden nach maximal 14 Tagen gelöscht oder anonymisiert.</p>

  <h2>5. Registrierung und Nutzerkonto</h2>
  <h3>Beschreibung</h3>
  <p>Für die Nutzung unserer Plattform ist eine Registrierung erforderlich. Dabei verarbeiten wir folgende Daten:</p>
  <p><strong>Endkunden:</strong> Vor- und Nachname, E-Mail-Adresse, Passwort (gehasht), optional Telefonnummer und Avatar.</p>
  <p>
    <strong>Handwerker (zusätzlich):</strong> Unternehmensdaten (Firmenname, Rechtsform, Anschrift),
    Steuerinformationen (USt-ID/Steuernummer), Stundensatz/Grundpreis, Aktionsradius, Gewerke und
    Spezialisierungen, Galeriebilder, Qualifikations- und Versicherungsnachweise (Dokumente).
  </p>
  <h3>Rechtsgrundlage</h3>
  <p>Art. 6 Abs. 1 lit. b DSGVO (Vertragsdurchführung).</p>
  <h3>Speicherdauer</h3>
  <p>
    Bis zur Löschung des Nutzerkontos. Gesetzliche Aufbewahrungsfristen (Handels- und Steuerrecht: 6
    bzw. 10 Jahre; Plattformsteuertransparenz nach PStTG: 10 Jahre für Handwerker-Stammdaten und
    Transaktionsdaten) bleiben unberührt.
  </p>

  <h2>6. Anmeldung über Drittanbieter (OAuth)</h2>
  <h3>Beschreibung</h3>
  <p>Wir bieten die Anmeldung über folgende Drittanbieter an:</p>
  <ul>
    <li><strong>Google</strong> (Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland)</li>
    <li><strong>Apple</strong> (Apple Distribution International Ltd., Hollyhill Industrial Estate, Hollyhill, Cork, Irland)</li>
  </ul>
  <p>
    Bei Anmeldung über einen dieser Dienste werden personenbezogene Daten (mindestens E-Mail, Name,
    eindeutige Anbieter-ID) vom jeweiligen Anbieter an uns übermittelt. Eine Übermittlung in Drittländer
    kann erfolgen; die Anbieter haben sich auf entsprechende Garantien (Standardvertragsklauseln)
    verpflichtet.
  </p>
  <h3>Rechtsgrundlage</h3>
  <p>
    Art. 6 Abs. 1 lit. b DSGVO (Vertragsanbahnung/-durchführung). Die Datenverarbeitung durch den
    Drittanbieter erfolgt auf Grundlage Ihrer dortigen Einwilligung.
  </p>

  <h2>7. Anfrage- und Vermittlungsprozess</h2>
  <h3>Beschreibung</h3>
  <p>Im Rahmen einer Auftragsanfrage verarbeiten wir:</p>
  <ul>
    <li>Antworten auf den geführten Wizard (z. B. Gewerk, Umfang, Wunschtermin)</li>
    <li>Ihre Anschrift und Postleitzahl (zur Geo-Suche, siehe Ziff. 8)</li>
    <li>hochgeladene Fotos und Notizen</li>
    <li>die ausgewählte Auftragsfreigabe an passende Handwerker im definierten Umkreis</li>
  </ul>
  <p>
    Handwerker erhalten zunächst nur ein eingeschränktes Profil der Anfrage <strong>ohne genaue Straße</strong>.
    Die vollständigen Kontaktdaten werden erst nach Buchung freigegeben.
  </p>
  <h3>Rechtsgrundlage</h3>
  <p>Art. 6 Abs. 1 lit. b DSGVO (Vertragsdurchführung).</p>
  <h3>Speicherdauer</h3>
  <p>
    Anfragedaten werden für die Dauer der laufenden Anfrage und anschließend für die Dauer gesetzlicher
    Aufbewahrungsfristen gespeichert. Nicht zu Buchungen führende Anfragen werden nach 12 Monaten
    anonymisiert.
  </p>

  <h2>8. Geocoding (Postleitzahl/Adresse)</h2>
  <h3>Beschreibung</h3>
  <p>
    Zur Umkreissuche verwenden wir den OpenStreetMap-Geocoding-Dienst <strong>Nominatim</strong>
    (OpenStreetMap Foundation, St John's Innovation Centre, Cowley Road, Cambridge CB4 0WS, Vereinigtes
    Königreich). Bei Eingabe einer PLZ oder Adresse wird die Eingabe an Nominatim übermittelt, um
    Geokoordinaten (Längen- und Breitengrad) zu ermitteln. Eine Übermittlung in Drittländer findet nicht
    statt.
  </p>
  <h3>Rechtsgrundlage</h3>
  <p>
    Art. 6 Abs. 1 lit. b DSGVO bzw. Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an der
    ortsbasierten Vermittlung).
  </p>

  <h2>9. Authentifizierung (Session-Cookie)</h2>
  <p>
    Wir verwenden einen technisch notwendigen, http-only-Session-Cookie zur Aufrechterhaltung Ihrer
    Anmeldung. Dieser Cookie speichert eine zufällige Sitzungs-ID für maximal 7 Tage (gleitend). Details
    siehe <a routerLink="/cookies">Cookie-Richtlinie</a>.
  </p>
  <p>
    Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO i. V. m. § 25 Abs. 2 Nr. 2 TDDDG (unbedingt erforderlich).
  </p>

  <h2>9a. Webanalyse mit Google Analytics 4</h2>
  <h3>Beschreibung</h3>
  <p>
    Nach Ihrer ausdrücklichen Einwilligung über unser Cookie-Banner nutzen wir <strong>Google
    Analytics 4</strong>, einen Webanalysedienst der <strong>Google Ireland Ltd.</strong> (Gordon House,
    Barrow Street, Dublin 4, Irland; im Verhältnis zu Nutzern außerhalb sowie für die Verarbeitung in den
    USA: Google LLC, 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA). Der Dienst dient der
    Reichweiten- und Nutzungsanalyse, um unser Angebot statistisch auszuwerten und zu verbessern.
  </p>
  <p>
    Google Analytics setzt Cookies (insbesondere <code>_ga</code> und <code>_ga_*</code>) und verarbeitet
    dabei insbesondere folgende Daten: gekürzte IP-Adresse (IP-Anonymisierung ist in GA4 standardmäßig
    aktiv), Geräte- und Browserinformationen, ungefährer Standort (Land/Region), aufgerufene Seiten und
    Nutzungsverhalten sowie eine pseudonyme Nutzer-/Sitzungs-Kennung. Ein Personenbezug zu Ihrer Identität
    wird von uns nicht hergestellt. „Google-Signale" sind in unserer Property deaktiviert.
  </p>
  <h3>Einwilligung und Widerruf</h3>
  <p>
    Das Analyse-Skript wird erst geladen, <strong>nachdem</strong> Sie im Cookie-Banner aktiv zugestimmt
    haben (Consent Mode v2, Standardeinstellung „denied"). Vor einer Einwilligung findet weder ein
    Zugriff auf Ihr Endgerät noch eine Datenübertragung an Google statt. Sie können Ihre Einwilligung
    jederzeit mit Wirkung für die Zukunft über den Link <strong>„Cookie-Einstellungen"</strong> im Footer
    widerrufen; bereits gesetzte Analytics-Cookies werden dabei gelöscht.
  </p>
  <h3>Rechtsgrundlage</h3>
  <p>
    Art. 6 Abs. 1 lit. a DSGVO (Einwilligung) i. V. m. § 25 Abs. 1 TDDDG.
  </p>
  <h3>Drittlandübermittlung (USA)</h3>
  <p>
    Bei der Nutzung von Google Analytics können personenbezogene Daten an Server von Google in den USA
    übermittelt werden. Google LLC ist nach dem <strong>EU-US Data Privacy Framework (DPF)</strong>
    zertifiziert; die Übermittlung erfolgt auf dieser Grundlage. Ergänzend hat sich Google auf die
    EU-Standardvertragsklauseln verpflichtet. Es besteht das grundsätzliche Risiko, dass US-Behörden
    Zugriff auf die Daten nehmen können.
  </p>
  <h3>Speicherdauer</h3>
  <p>
    Die Cookies <code>_ga</code>/<code>_ga_*</code> haben eine Laufzeit von bis zu 24 Monaten. Die
    Aufbewahrungsdauer der Nutzungs- und Ereignisdaten auf Ebene der GA4-Property ist auf die kürzeste
    verfügbare Stufe begrenzt. Details zu den von Google gesetzten Cookies siehe
    <a routerLink="/cookies">Cookie-Richtlinie</a>.
  </p>

  <h2>10. Foto- und Dokumenten-Upload</h2>
  <p>
    Hochgeladene Fotos und Dokumente werden auf unseren Servern in Deutschland gespeichert. Sie können
    diese im Bereich „Mein Konto" jederzeit einsehen und löschen.
  </p>
  <p>Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO.</p>

  <h2>10a. Verarbeitung von Mängelfall-Daten</h2>
  <h3>Beschreibung</h3>
  <p>Im Rahmen einer Mängelmeldung verarbeiten wir folgende Daten:</p>
  <ul>
    <li>Beschreibung des Mangels</li>
    <li>Hochgeladene Fotos, Videos oder Dokumente (Beweismittel)</li>
    <li>Kommunikation zwischen Endkunde und Handwerker im Vermittlungsverfahren</li>
    <li>
      Entscheidungen unseres Service-Teams (für statistische Auswertung nach Abschluss anonymisiert)
    </li>
  </ul>
  <p>
    Bei Foto-Uploads werden <strong>Geo-Standortdaten (EXIF)</strong> automatisch entfernt, bevor die
    Daten unsere Server erreichen — das clientseitige Stripping erfolgt im Wizard noch vor dem
    Upload. Das <strong>Aufnahmedatum und die -uhrzeit</strong> werden beibehalten, weil sie für die
    Beweiskraft im Vermittlungsverfahren relevant sind.
  </p>
  <h3>Rechtsgrundlage</h3>
  <p>
    Art. 6 Abs. 1 lit. b DSGVO (Vertragsdurchführung) und Art. 6 Abs. 1 lit. f DSGVO
    (berechtigtes Interesse an Streitbeilegung und Plattform-Integrität).
  </p>
  <h3>Speicherdauer</h3>
  <p>
    Mängelfälle und zugehörige Beweismittel werden während der Vertragslaufzeit zuzüglich
    <strong>3 Jahre Verjährungsfrist</strong> aufbewahrt (§§ 195, 199 BGB). Bei Buchhaltungs­relevanz
    (Refund) gilt zusätzlich § 147 AO mit <strong>10 Jahren</strong>.
  </p>

  <h2>10b. SEPA-Lastschriftmandat (nur Handwerker)</h2>
  <h3>Beschreibung</h3>
  <p>
    Erteilt der Handwerker im Onboarding ein SEPA-Lastschriftmandat, verarbeiten wir folgende Daten
    als Audit-Nachweis: Zeitpunkt der Erteilung, IP-Adresse, Browser-Identifikation (User-Agent), ein
    Hash der hinterlegten IBAN sowie die generierte Mandatsreferenz.
  </p>
  <p>
    Die <strong>volle IBAN</strong> wird nicht bei uns gespeichert; sie liegt ausschließlich beim
    Zahlungsdienstleister Stripe. Wir speichern lediglich einen kryptographischen Hash zur
    Mandat-Identifikation.
  </p>
  <h3>Rechtsgrundlage</h3>
  <p>
    Art. 6 Abs. 1 lit. b DSGVO (Vertragsdurchführung) sowie Art. 6 Abs. 1 lit. f DSGVO
    (berechtigtes Interesse an Beitreibung offener Forderungen).
  </p>
  <h3>Speicherdauer</h3>
  <p>
    Audit-Daten zum Mandat werden auch nach Widerruf des Mandats für die Verjährungsfrist von 3
    Jahren aufbewahrt — zur Nachweisführung gegenüber Banken bei Rückbuchungen (§ 675x BGB).
  </p>

  <h2>11. Empfänger personenbezogener Daten / Auftragsverarbeitung</h2>
  <p>
    Personenbezogene Daten werden nur weitergegeben, soweit dies zur Vertragsdurchführung oder aufgrund
    gesetzlicher Pflicht erforderlich ist. Empfänger sind insbesondere:
  </p>
  <ul>
    <li>der bei Buchung ausgewählte Handwerker (Kontakt- und Auftragsdaten)</li>
    <li>der Endkunde (im Rahmen abgegebener Angebote)</li>
    <li>IT-Dienstleister im Rahmen einer Auftragsverarbeitung gemäß Art. 28 DSGVO</li>
    <li>Steuerbehörden (insbes. Bundeszentralamt für Steuern im Rahmen des PStTG, sofern anwendbar)</li>
    <li>Behörden bei gesetzlicher Verpflichtung</li>
  </ul>

  <h2>12. Gemeinsame Verantwortlichkeit (Art. 26 DSGVO)</h2>
  <p>
    Soweit Endkunden und Handwerker im Rahmen der Vermittlung Daten austauschen und Craftly hierfür den
    Rahmen vorgibt (Profilanzeige, Anfrage-Routing, Bewertungen), liegt eine
    <strong>gemeinsame Verantwortlichkeit</strong> zwischen Kulatrix UG und dem jeweiligen Handwerker
    im Sinne von Art. 26 DSGVO vor.
  </p>
  <p>Wesentliche Inhalte der Vereinbarung über die gemeinsame Verantwortlichkeit:</p>
  <ul>
    <li>
      <strong>Kulatrix UG</strong> ist primärer Ansprechpartner für Betroffenenrechte und übernimmt die
      Erstinformation der Nutzer.
    </li>
    <li>
      <strong>Der Handwerker</strong> ist verantwortlich für die rechtmäßige Verarbeitung der nach
      Buchung übermittelten Endkundendaten (z. B. Kontaktdaten, Adresse) sowie der Daten, die im Rahmen
      der Auftragsdurchführung anfallen (z. B. Rechnungen).
    </li>
    <li>
      Beide Parteien gewähren Betroffenen jeweils sämtliche Rechte gemäß Art. 15 ff. DSGVO. Anfragen
      können an einen der Beteiligten gerichtet werden; die Bearbeitung erfolgt in Abstimmung.
    </li>
  </ul>
  <p>
    Betroffene können ihre Rechte unabhängig von dieser Aufgabenverteilung gegenüber jedem der gemeinsam
    Verantwortlichen geltend machen (Art. 26 Abs. 3 DSGVO).
  </p>

  <h2>13. Plattformsteuertransparenz (DAC7 / PStTG)</h2>
  <p>
    Soweit ein Handwerker als „Anbieter" im Sinne des Plattformen-Steuertransparenzgesetzes (PStTG) gilt
    und die Schwellen überschreitet (mehr als 30 relevante Tätigkeiten oder mehr als 2.000 € Vergütung
    im Kalenderjahr), sind wir gesetzlich verpflichtet, Stammdaten (Name, Anschrift,
    Steueridentifikationsnummer, USt-ID, Bankverbindung), Vergütungen und Provisionen jährlich an das
    Bundeszentralamt für Steuern zu melden und für 10 Jahre aufzubewahren.
  </p>
  <p>Rechtsgrundlage: Art. 6 Abs. 1 lit. c DSGVO i. V. m. PStTG.</p>

  <h2>14. Speicherdauer / Löschung</h2>
  <p>
    Wir speichern personenbezogene Daten nur so lange, wie es zur Erreichung des jeweiligen Zwecks
    erforderlich ist oder wie wir gesetzlich dazu verpflichtet sind. Anschließend werden die Daten
    gelöscht oder anonymisiert. Die wichtigsten Fristen:
  </p>
  <table>
    <thead>
      <tr><th>Datenkategorie</th><th>Frist</th></tr>
    </thead>
    <tbody>
      <tr><td>Server-Logs</td><td>14 Tage</td></tr>
      <tr><td>Nicht zu Buchung führende Anfragen</td><td>12 Monate (dann anonymisiert)</td></tr>
      <tr><td>Buchungs- und Vertragsdaten</td><td>bis Vertragsende, danach 6 Jahre (HGB) bzw. 10 Jahre (AO)</td></tr>
      <tr><td>Steuermeldedaten (PStTG)</td><td>10 Jahre</td></tr>
      <tr><td>Nutzerkonto-Stammdaten</td><td>bis Kontolöschung</td></tr>
    </tbody>
  </table>

  <h2>15. Ihre Rechte als betroffene Person</h2>
  <p>Sie haben jederzeit das Recht auf:</p>
  <ul>
    <li><strong>Auskunft</strong> über die zu Ihrer Person gespeicherten Daten (Art. 15 DSGVO)</li>
    <li><strong>Berichtigung</strong> unrichtiger Daten (Art. 16 DSGVO)</li>
    <li><strong>Löschung</strong> („Recht auf Vergessenwerden", Art. 17 DSGVO)</li>
    <li><strong>Einschränkung</strong> der Verarbeitung (Art. 18 DSGVO)</li>
    <li><strong>Datenübertragbarkeit</strong> (Art. 20 DSGVO)</li>
    <li><strong>Widerspruch</strong> gegen Verarbeitungen, die auf Art. 6 Abs. 1 lit. f DSGVO beruhen (Art. 21 DSGVO)</li>
    <li><strong>Widerruf</strong> erteilter Einwilligungen mit Wirkung für die Zukunft (Art. 7 Abs. 3 DSGVO)</li>
  </ul>
  <p>
    Eine Datenexport-Funktion („Mein Konto" → „Daten exportieren") steht Ihnen zur direkten Wahrnehmung
    des Auskunfts- und Übertragbarkeitsrechts zur Verfügung.
  </p>

  <h2>16. Beschwerderecht bei der Aufsichtsbehörde</h2>
  <p>Sie haben das Recht, sich bei einer Datenschutz-Aufsichtsbehörde zu beschweren. Zuständig für uns ist:</p>
  <address class="cr-legal__address">
    <strong>Landesbeauftragte für Datenschutz und Informationsfreiheit Nordrhein-Westfalen (LDI NRW)</strong><br>
    Kavalleriestraße 2–4<br>
    40213 Düsseldorf<br>
    <a href="mailto:poststelle&#64;ldi.nrw.de">poststelle&#64;ldi.nrw.de</a>
  </address>

  <h2>17. Änderungen dieser Datenschutzerklärung</h2>
  <p>
    Wir behalten uns vor, diese Datenschutzerklärung anzupassen, damit sie stets den aktuellen
    rechtlichen Anforderungen entspricht oder Änderungen unserer Leistungen umzusetzen. Für Ihren
    erneuten Besuch gilt die jeweils aktuelle Fassung.
  </p>

</app-legal-layout>
